import { ComboboxTranslations, SuggestionWithIdAndValue } from '../ComboboxTypes';

const isPlural = (array: SuggestionWithIdAndValue[]) => array.length > 1 || array.length === 0;

const defaultTranslations: ComboboxTranslations = {
    result: 'resultat',
    results: 'resultater',
    noResults: 'Ingen resultater',
};

const getAriaText = (
    suggestions: SuggestionWithIdAndValue[],
    value: string,
    translations = defaultTranslations,
): string => {
    if (!suggestions) return '';

    const filteredSuggestionsByInputValue = suggestions.filter((suggestion) =>
        suggestion.value.toLowerCase().includes(value.toLowerCase()),
    );

    return filteredSuggestionsByInputValue.length
        ? `${filteredSuggestionsByInputValue.length} ${
              isPlural(filteredSuggestionsByInputValue) ? translations.results : translations.result
          }`
        : translations.noResults;
};

export default getAriaText;
